'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { FC, useState } from 'react';
import Icon from '~/components/icon';
import ILink from '~/data/strapi/types/shared-components/link';
import Sublink from '~/data/strapi/types/shared-components/link/sub-link';

import { useBurgerMenu } from '../../../context';
import styles from './styles.module.css';

interface Props {
  parentHref: string | null;
  link: ILink | Sublink;
  sublinks: Sublink[];
  onClose: () => void;
}

const BurgerSublinks: FC<Props> = ({ link, sublinks, onClose, parentHref }) => {
  const [openedLink, setOpenedLink] = useState<Sublink | null>(null);
  const currentHref = openedLink && openedLink.href;
  const currentParentHref = parentHref ? `${parentHref}/${currentHref}` : `/${currentHref}`;
  const { closeMenu } = useBurgerMenu();

  return (
    <>
      {!openedLink && (
        <ul className={clsx(styles.sublist)}>
          <li className={styles.linkMain} onClick={onClose}>
            <div className={styles.headingLink}>
              <Icon name="chevron" className={styles.iconLeft} /> {link?.title}
            </div>
          </li>
          {link.burgerMenuGroupTitle && parentHref && (
            <li className={styles.linkSub}>
              <Link onClick={closeMenu} href={`/${parentHref}`}>
                {link.burgerMenuGroupTitle}
              </Link>
            </li>
          )}
          {sublinks.map((link) => {
            const isNestedLinks = Boolean(link.links?.length);
            const href = parentHref ? `/${parentHref}/${link.href}` : `/${link.href}`;
            return (
              <li key={link.id} className={styles.link}>
                {isNestedLinks ? (
                  <div className={styles.nestedLink} onClick={() => setOpenedLink(link)}>
                    {link.title} <Icon name="chevron" className={styles.iconRight} />
                  </div>
                ) : (
                  <Link onClick={closeMenu} href={href}>
                    {link.title}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      )}
      {openedLink && openedLink.links && (
        <BurgerSublinks
          parentHref={currentParentHref}
          link={openedLink}
          sublinks={openedLink.links}
          onClose={() => setOpenedLink(null)}
        />
      )}
    </>
  );
};

export default BurgerSublinks;
